export default {
  myBalance: 'Mon solde',
  topUp: 'Recharger',
  pay: 'Recharger',
  repayment: 'Remboursement',
  balance: 'Solde',
  usableBalance: 'Crédit disponible',
  inputBalance: 'Veuillez saisir le montant',
  payBalance: 'Montant du rechargement',
  pecenter: 'Centre personnel',
  lang: 'Langue',
  cart: 'Panier',
  recipientName: 'Destinataire',
  goRecharge: 'Recharger maintenant',
  phone: 'Téléphone',
  region: 'Région',
  address: 'Adresse détaillée',
  country: 'Pays ou région',
  province: 'Province',
  city: 'Ville',
  postcode: 'Code postal',
  action: 'Opération',
  mobileSettings: 'Paramètres mobiles',
  name: 'Nom',
  debt: 'DETTE',
  add: 'Ajouter une adresse de facturation de carte de crédit',
  addSuccess: 'Ajout réussi',
  editSuccess: 'Modification réussie',
  editBtn: 'Modifier',
  edit: "Modifier l'adresse de facturation de la carte de crédit",
  del: 'Supprimer',
  setDefault: 'Définir par défaut',
  defaultAddress: 'Adresse par défaut',
  setDefaultAddress: 'Définir comme adresse de livraison par défaut',
  setSuccess: 'Définition réussie',
  myAddress: 'Mes adresses',
  addAddress: 'Ajouter une nouvelle adresse',
  tradeTime: 'Heure de la transaction',
  type: 'Type',
  incomeOrExpend: 'Revenu/Dépense',
  accountBalance: 'Solde du compte',
  tradeNo: 'ID de transaction',
  remark: 'Remarque',
  tag: "Libellé de l'adresse",
  addBillAddress: 'Ajouter une adresse de facturation de carte de crédit',
  deleteBillAddress: "Supprimer l'adresse de facturation",
  editBillAddress: "Modifier l'adresse de facturation",
  mergePay: 'Payer ensemble',
  username: "Nom d'utilisateur",
  gender: 'Sexe',
  birthday: 'Date de naissance',
  avatar: 'Avatar',
  email: 'E-mail',
  site: 'Site',
  myOrder: 'Commande',
  sideBar: {
    myAccount: 'Mon compte',
    addressManage: 'Gestion des adresses',
    myAsset: 'Portefeuille',
    billAddress: 'Adresse de facturation',
  },
  addDoorNoTips: 'Veuillez ajouter le numéro de maison à votre adresse de livraison.',
  holder: {
    receiver: 'Destinataire',
    firstName: 'Prénom',
    name: 'Nom de famille',
    region: 'Veuillez sélectionner la province/la ville/le district/la rue',
    address:
      "Veuillez saisir des informations d'adresse détaillées, telles que la rue, le numéro de maison, la communauté, le numéro de bâtiment, l'unité, etc.",
    phone: 'Numéro de téléphone, le numéro de téléphone portable doit être renseigné dans un champ',
    input: 'veuillez saisir',
    select: 'veuillez sélectionner',
    tagHolder: 'Max. 120 caractères (facultatif)',
    postCodeNoMatch: 'Le code postal ne correspond pas à la région',
    doorNo: 'Numéro de maison',
  },
  forget: {
    accountSafe: 'Sécurité du compte',
    setPwd: 'Modifier le mot de passe',
    inputBindEmail: 'Veuillez saisir votre e-mail lié',
    inputVerifyCode: 'Veuillez saisir le code de vérification',
    inputPwd: 'Veuillez saisir le nouveau mot de passe',
  },
  accountInfo: {
    name: 'Compte',
    selfInfo: 'Informations personnelles',
    cardBillAddress: 'Adresse de facturation de la carte de crédit',
    shipAddress: 'Adresse de livraison',
    editUser: "Modifier les informations de l'utilisateur",
    inputCountry: 'Veuillez saisir votre pays',
    editEmail: "Modifier l'e-mail",
    editEmailHint:
      "(Recommandé uniquement lorsque l'e-mail est mal configuré ou présente des problèmes)",
    editEmailHint1:
      "Pour la sécurité de votre compte, vous devez d'abord passer la vérification de sécurité avec « Code de vérification par e-mail + mot de passe de connexion »",
    editEmailHint2:
      "Pour la sécurité de votre compte, vous devez d'abord passer la vérification de sécurité avec « Code de vérification par e-mail »",
    currentEmail: 'E-mail actuel',
    clickVerify: 'Envoyer',
    reGet: 'Renvoyer',
    nextStep: 'Étape suivante',
    notReGetCode: 'Renvoyer après',
    logoutAccount: 'Se déconnecter du compte',
    emailNotEmpty: "L'e-mail ne peut pas être vide",
    logoutReason: 'Veuillez sélectionner le motif de la déconnexion',
    latelyLogin: 'Dernière connexion',
    moreRecord: "Plus d'enregistrements",
    visitRecord: 'Historique des visites',
    visitTime: 'Heure de la visite',
    ipAndDevice: "Adresse IP et type d'appareil",
    editLoginPwdHint:
      "Un mot de passe à haute sécurité peut rendre votre compte plus sûr. Il est recommandé de modifier régulièrement votre mot de passe et de définir un mot de passe comprenant des chiffres et des lettres et d'une longueur supérieure à 6 chiffres.",
    editPayPwdHint:
      "Le mot de passe requis lors de l'utilisation du solde acbuy pour payer, définissez le mot de passe de paiement pour assurer la sécurité du paiement.",
    editVerifyEmailHint:
      'Afin de protéger la sécurité de votre compte, veuillez vérifier votre e-mail.',
    payPwd: 'Mot de passe de paiement',
    editPayPwd: 'Modifier le mot de passe de paiement',
    setPayPwd: 'Définir le mot de passe de paiement',
    deleteAccount: 'Supprimer le compte',
  },
  logoutReasonEnum: {
    0: 'Problèmes de sécurité/confidentialité',
    1: 'Service client médiocre',
    2: 'Coûts trop élevés',
    3: "Processus d'achat compliqué",
    4: 'Autres raisons',
  },
  tradeTypeEnum: {
    0: 'Revenu',
    1: 'Dépense',
  },
  asset: {
    currentBalance: 'Solde actuel',
    canWithdrawBalance: 'Montant disponible pour le retrait',
    withdraw: 'Retirer',
    serialNo: 'N° de série',
    amount: 'Montant',
    lossAmount: 'Montant dépensé',
    withdrawAmount: 'Montant du retrait',
    inputWithdrawAmount: 'Veuillez saisir le montant du retrait',
    withdrawSuccess: "Retrait soumis, le traitement peut prendre jusqu'à 72 heures.",
    transactionDate: 'Date de la transaction',
    withdrawMethod: 'Méthode de retrait',
    availableAmount: 'Montant disponible',
    transactionNo: 'Numéro de transaction',
    withdrawMsg:
      "Remarque : Le retrait du solde sera retourné via le canal d'origine. Le solde sera retourné sur le compte de paiement de la transaction de retrait conformément à l'historique des dépenses.",
    transactionRecordsText: 'Historique des transactions du montant disponible',
    withdrawRecordText: 'Historique des retraits',
  },
  package: {
    packageInfo: 'Informations sur le colis',
    weightHaveUnit: 'Poids (g)',
    sizeHaveUnit: 'Taille (cm)',
    freight: 'Fret',
    fee: 'Frais',
    transportMode: 'Mode de livraison',
    allPackage: 'Tous les colis',
    myPackage: 'Colis',
  },
  packageStatusEnum: {
    0: 'Fonds en attente',
    1: 'Non payé',
    2: 'En transit',
    3: 'Terminé',
    4: 'Annulé',
  },
  storage: {
    name: 'Entrepôt',
    warehouseTime: "Heure d'entrée en entrepôt",
    submitTransport: 'Soumettre pour la livraison',
    lineCanUse: 'Pièces disponibles',
    commonImg: 'Photos QC',
    customPhoto: 'Photos personnalisées',
    extendCare: 'Prolonger la période de stockage',
    extendHint:
      "La période de stockage de vos marchandises dans l'entrepôt sera prolongée de (30 * N) jours. La nouvelle date d'expiration est",
    packMode: "Méthode d'emballage",
    retainPack: 'Emballage réservé',
    normalPack: 'Emballage par défaut',
    normalPackHint: "Les articles seront emballés avec leur emballage d'origine.",
    foldPack: 'Emballage plié',
    foldPackHint:
      "Pour les cartons non fixés par de la colle, l'entrepôt les démontera, les pliera à plat et les mettra dans le colis de l'utilisateur, ce qui peut réduire le volume du colis dans une certaine mesure. Mais il existe également des cas d'augmentation du volume du colis (lorsqu'il y a moins de marchandises, la longueur et la largeur de pliage du carton peuvent augmenter).",
    discardPack: "Jeter l'emballage",
    discardPackHint:
      "Une fois l'emballage jeté, le vendeur peut ne pas accepter de service après-vente et le colis ne pourra pas être retrouvé/ajouté à nouveau.",
    photoTemplate: 'Modèle de photo',
  },
  operate: 'Opération',
  editAddress: "Modifier l'adresse",
  underPaid: 'Non payé',
  goTopay: 'Aller payer',
  viewRecord: "Afficher l'historique",
  faq: 'FAQ',
  question1: 'Q : Mon compte sera-t-il gelé si je soumets une demande de retrait ?',
  response1:
    "R : Après avoir demandé un retrait, le compte gèlera le montant de la demande pour s'assurer que le montant du remboursement correspond au montant que vous avez demandé.",
  question2:
    "Q : Est-ce que « Terminé » dans l'historique des retraits signifie que le retrait des fonds a réussi ?",
  response2:
    "R : « Terminé » signifie qu'acbuy a organisé un remboursement, mais le délai d'arrivée sur votre compte d'origine dépend du délai de traitement de la plateforme tierce.",
  question3: 'Q : Le retrait est-il basé sur le taux de change en temps réel ?',
  response3:
    'R : Non, le taux de change du retrait est basé sur le moment où les fonds ont été rechargés.',
  question4:
    'Q : Comment effectuer un retrait lorsque le solde du compte est différent du montant du retrait ?',
  response4:
    "R : Lorsque le solde du compte est supérieur au montant du retrait, vous pouvez effectuer des demandes par lots jusqu'à ce que le solde du compte soit de 0. Lorsque le solde du compte est inférieur au montant du retrait, vous pouvez demander un retrait unique du montant total.",
  stillRecharge: 'Pas assez pour payer la commande, veuillez recharger',
  amountDue: 'Montant dû',
  handingFee: 'Frais de traitement',
  coupon: 'Coupon',
  couponPlaceholder: 'Échangez des coupons avec des codes de coupon',
  off: 'RÉDUCTION',
  minFee: 'Frais min.',
  freightText: 'Fret',
  limitTo: 'Limite à',
  shippingUsage: "Utilisation de l'expédition",
  availableWarehouse: 'Entrepôt disponible',
  shippingFeeText: "Frais d'expédition (hors frais de dédouanement)",
  internationalParcel: 'Colis international',
  to: 'à',
  availableCoupons: 'Coupons disponibles',
  usedCoupons: 'Coupons utilisés',
  expiredCoupons: 'Coupons expirés',
  exchangeSuccess: 'Échange réussi !',
  myAffiliate: {
    name: 'Affilié',
  },
  affiliateShare: 'Partager',
  copyText: 'Copier',
  affiliateShareMsg:
    "Les paiements d'expédition effectués via des liens partagés généreront des revenus de commission pour vous.",
  businessType: "Type d'activité",
  payWay: 'Type de transaction',
  bzOrderNo: 'N° AC',
  amountDueTooltip:
    "En raison des calculs de conversion du taux de change, il peut y avoir une différence d'environ 0,01 ou 0,02",
  balanceStatement: 'Relevé de solde',
  billFlow: 'Facture',
  affiliateFavorite: 'favori',
  favourite: 'Favori',
  canUseCountry: 'Pays disponible',
  commonNo: 'N°',
  question5: 'Q : Jak długo trzeba czekać na wypłatę środków na mojej karcie?',
  response5:
    'R : Le délai de traitement des retraits peut varier selon le mode de paiement et la banque, généralement entre 2 et 25 jours. En temps normal, les retraits seront remboursés sur votre mode de paiement initial ou de rechargement sous 48 heures. Si vous ne recevez pas le retrait sous 48 heures, vous pouvez contacter le service client pour vérifier son statut.',
}
